import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import ActionButton from "../ActionButton";

import { useStore } from "../../connect";

import strings from "../../locales/strings";

const SearchButton = ({ isSmall, hideTooltip }) => {
  const { notifications, search } = useStore();

  return (
    <ActionButton
      tooltipText={strings.searchParticipants}
      isSmall={isSmall}
      iconName="ic_search-people"
      onClick={search.showSearch}
      active={search.searchVisible}
      hideTooltip={
        notifications.showNotificationDropdown ||
        search.searchVisible ||
        hideTooltip
      }
    />
  );
};

SearchButton.propTypes = {
  isSmall: PropTypes.bool,
  hideTooltip: PropTypes.bool,
};

export default observer(SearchButton);
